import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
// hooks
import useAuth from '../hooks/useAuth';

AdminGuard.propTypes = {
  children: PropTypes.node
};

export default function AdminGuard({ children }) {
  const { isAuthenticated, isWebVersion, role } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if ( isWebVersion() ) {
    return <Navigate to="/" />;
  }

  if (!isAuthenticated) {
      return <Navigate to="/auth/login" />;
  }

  if (role !== 'ADMIN') {
      return <Navigate to="/404" />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
      setRequestedLocation(null);
      return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
